export enum ECheckAndApplyResultEnum {
  OK = 0,
  AlreadyApplied = 1,
  UpsellNotAvailable = 2,
}